'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, type TransitionStartFunction, useEffect, useTransition } from 'react';
import { useSessionSync } from '@/entities/session/model/sessionSyncContext';
import type { BranchId } from '@/shared/config/funnel/constants';
import type { FlattenedFunnelConfig } from '@/shared/config/funnel/flattened/types';
import type { FunnelStepSnapshot } from '../stepSnapshot';
import { useHandleLanding } from './hooks';
export type FunnelContextValue = {
  funnelFlattenedConfig: FlattenedFunnelConfig;
  stepId: string;
  branchId: BranchId | null;
  isFirstStep: boolean;
  isBranchFirstStep: boolean;
  isBranchLastStep: boolean;
  progress: number;
  funnelConfigVersion: string;
  isSubmitting: boolean;
  startSubmitTransition: TransitionStartFunction;
};
export const FunnelContext = createContext<FunnelContextValue | undefined>(undefined);
type FunnelProviderProps = {
  children: ReactNode;
  funnelFlattenedConfig: FlattenedFunnelConfig;
  stepSnapshot: FunnelStepSnapshot;
  branchId: BranchId | null;
  funnelConfigVersion: string;
};
export function FunnelProvider(t0) {
  const $ = _c(22);
  const {
    children,
    funnelFlattenedConfig,
    stepSnapshot,
    branchId,
    funnelConfigVersion
  } = t0;
  const {
    stepId,
    isFirstStep,
    isBranchFirstStep,
    isBranchLastStep,
    progress
  } = stepSnapshot;
  let t1;
  if ($[0] !== branchId || $[1] !== funnelFlattenedConfig || $[2] !== stepSnapshot) {
    t1 = {
      funnelFlattenedConfig,
      stepSnapshot,
      branchId
    };
    $[0] = branchId;
    $[1] = funnelFlattenedConfig;
    $[2] = stepSnapshot;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useHandleLanding(t1);
  const [isSubmitting, startSubmitTransition] = useTransition();
  const {
    syncOnLogin
  } = useSessionSync();
  let t2;
  let t3;
  if ($[4] !== branchId || $[5] !== funnelConfigVersion || $[6] !== syncOnLogin) {
    t2 = () => {
      syncOnLogin(branchId, funnelConfigVersion, startSubmitTransition);
    };
    t3 = [syncOnLogin, branchId, funnelConfigVersion, startSubmitTransition];
    $[4] = branchId;
    $[5] = funnelConfigVersion;
    $[6] = syncOnLogin;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== branchId || $[10] !== funnelConfigVersion || $[11] !== funnelFlattenedConfig || $[12] !== isBranchFirstStep || $[13] !== isBranchLastStep || $[14] !== isFirstStep || $[15] !== isSubmitting || $[16] !== progress || $[17] !== stepId) {
    t4 = {
      funnelFlattenedConfig,
      stepId,
      branchId,
      isFirstStep,
      isBranchFirstStep,
      isBranchLastStep,
      progress,
      funnelConfigVersion,
      isSubmitting,
      startSubmitTransition
    };
    $[9] = branchId;
    $[10] = funnelConfigVersion;
    $[11] = funnelFlattenedConfig;
    $[12] = isBranchFirstStep;
    $[13] = isBranchLastStep;
    $[14] = isFirstStep;
    $[15] = isSubmitting;
    $[16] = progress;
    $[17] = stepId;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const value = t4;
  let t5;
  if ($[19] !== children || $[20] !== value) {
    t5 = <FunnelContext.Provider value={value}>{children}</FunnelContext.Provider>;
    $[19] = children;
    $[20] = value;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}